import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import * as feather from 'feather-icons';
import { RouterService } from './shared/services/router.service';
import { Subscription, timer } from 'rxjs';
import { SharedService } from './shared/shared.service';
import { WebsocketService } from './shared/services/websocket.service';
import { AuthService } from './shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  showLoader = false;
  showLoader1 = false;
  loaderSubscription!: Subscription;
  loaderSubscription1!: Subscription;
  websocketSubscription!: Subscription;
  messages: string[] = [];
  serverUrl: string = '';
  authToken: any;
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private reconnectDelay = 1000; // Initial delay in ms
  private isConnecting = false;

  constructor(
    private _route: Router,
    private routerService: RouterService,
    private websocketService: WebsocketService,
    private auth: AuthService,
    private sharedService: SharedService,
    private cdRef: ChangeDetectorRef
  ) {
    this.serverUrl = `${environment.WebsocketUrl}`;
    this.authToken = this.auth.getAuthToken() ? this.auth.getAuthToken() : localStorage.getItem('access_token');
    this.connectWebSocket();
  }

  private connectWebSocket(): void {
    if (this.isConnecting) {
      return;
    }

    this.isConnecting = true;
    if (this.websocketSubscription) {
      this.websocketSubscription.unsubscribe();
    }

    console.log(`Connecting to WebSocket. Attempt ${this.reconnectAttempts + 1}`);
    this.websocketSubscription = this.websocketService.connect(this.serverUrl, this.authToken).subscribe(
      (message: MessageEvent) => {
        this.messages.push(message.data);
        console.log('WebSocket message:', message.data, this._route.url);
        this.reconnectAttempts = 0; // Reset attempts on successful connection
        this.isConnecting = false;
        this.cdRef.markForCheck();
      },
      (error) => {
        console.error('WebSocket error:', error);
        this.isConnecting = false;
        this.attemptReconnect();
      },
      () => {
        console.log('WebSocket connection closed');
        this.isConnecting = false;
        this.attemptReconnect();
      }
    );

    const user_details = localStorage.getItem('user_details');
    if (user_details) {
      localStorage.setItem('isloggedin', 'true');
    } else {
      localStorage.setItem('isloggedin', 'false');
    }
  }

  private attemptReconnect(): void {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      const delay = this.reconnectDelay * Math.pow(2, this.reconnectAttempts); // Exponential backoff
      console.log(`Reconnecting in ${delay}ms... Attempt ${this.reconnectAttempts + 1}`);
      this.reconnectAttempts++;

      timer(delay).subscribe(() => {
        this.connectWebSocket();
      });
    } else {
      console.error('Max reconnect attempts reached. Giving up.');
    }
  }

  ngOnInit(): void {
    this.loaderSubscription = this.sharedService.loaderState$.subscribe((state: any) => {
      this.showLoader = state;
      this.cdRef.markForCheck();
    });
    this.loaderSubscription1 = this.sharedService.loaderState1$.subscribe((state: any) => {
      this.showLoader1 = state;
      this.cdRef.markForCheck();
    });
    this.routerService.ActivateRouteService();
  }

  ngOnDestroy(): void {
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
    if (this.loaderSubscription1) {
      this.loaderSubscription1.unsubscribe();
    }
    if (this.websocketSubscription) {
      this.websocketSubscription.unsubscribe();
    }
    this.websocketService.close();
  }

  sendMessage(message: string): void {
    this.websocketService.send(message);
  }

  ngAfterViewInit(): void {
    feather.replace();
  }
}